module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"name":"Name","example":"Franz jagt im komplett verwahrlosten Taxi quer durch Bayern."}}')
  delete Component.options._Ctor
}
